export default __webpack_public_path__ + "static/media/ict.ce507506.png";